import { useGetHealthAppStepQuery } from "types/generated/operations";
import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { getProspectUuid } from "utils/idHelpers";
import CensusAndCurrentInformation from "./CensusAndCurrentInformation";
import { getAppType } from "utils/helper";

const CensusAndCurrentInformationModel = (): JSX.Element => {
  const { data, error, loading } = useGetHealthAppStepQuery({
    variables: { uuid: getProspectUuid(), appType: getAppType() },
    fetchPolicy: "no-cache",
  });

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <ErrorPage />;
  }

  return <CensusAndCurrentInformation data={data?.prospect} />;
};
export default CensusAndCurrentInformationModel;
